import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef, jenkinsRouteRef, awsRouteRef, azureRouteRef, gcpRouteRef } from './routes';

export const selfServicePlugin = createPlugin({
  id: 'self-service',
  routes: {
    root: rootRouteRef,
    jenkins: jenkinsRouteRef,
    aws: awsRouteRef,
    azure: azureRouteRef,
    gcp: gcpRouteRef,
  },
});

export const SelfServicePage = selfServicePlugin.provide(
  createRoutableExtension({
    name: 'SelfServicePage',
    component: () =>
      import('./components/SelfService').then(m => m.SelfServiceLanding),
    mountPoint: rootRouteRef,
  }),
);
